<div class="select-fare">

  <div class="accordion" [id]="accordionId">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button  booking-sub-heading" type="button" data-bs-toggle="collapse"
          [attr.data-bs-target]="'#'+accordionId + 'Collapse'" aria-expanded="true" aria-controls="collapseOne">
          Flight details
          <fa-icon [icon]="icons.caretDown" size="2x" class="ms-2"></fa-icon>
        </button>
      </h2>
      <div [id]="accordionId+'Collapse'" class="accordion-collapse " aria-labelledby="headingOne"
        [attr.data-bs-parent]="'#'+accordionId">
        <div class="accordion-body">
          <div class="d-flex gap-3">
            <fa-icon [icon]="icons.departure"></fa-icon>
            <div>
              <p class="mb-2">
                Flight number: {{data?.flights[0]?.info.operating_airline_code+''+data?.flights[0]?.info.flight_number}}
              </p>
              <p class="mb-2">
                Duration: {{data?.flights[0]?.info.duration | flyOverDuration}}
              </p>
              <div class="mb-4">
                <p class="mb-2">
                  {{data?.departure?.datetime?.time_12h}} - {{data?.departure?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.departure?.airport?.name + ' ' + data?.departure?.airport?.code }}
                </p>
              </div>

              <div class="mb-4">
                <p class="mb-2">
                  <!-- 4h 30m flight -->
                </p>
                <p class="mb-2">
                  Operating Airline: {{data?.flights[0]?.info?.operating_airline}}
                </p>
                <p class="mb-2">
                  Marketing Airline: {{data?.flights[0]?.info?.marketing_airline}}
                </p>
                <p class="mb-2">
                  {{data?.flights[0]?.info?.aircraft}}
                </p>
                <p class="mb-2">
                  {{data?.flights[0]?.info?.aircraft_type}}
                </p>
                <p class="mb-2">
                  {{data?.flights[0]?.info?.cabin_name}}
                </p>
                <div *ngIf="data?.flights[0]?.info?.notes?.length > 0">
                  Notes:
                  <ul >
                    <li *ngFor="let item of data?.flights[0]?.info?.notes" class="mb-0">{{item?.value}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="stopCount === 1">

            <div class="d-flex gap-3 mt-1">
              <fa-icon [icon]="icons.arrival"></fa-icon>
              <div class="mb-2">
                <p class="mb-2">
                  {{data?.flights[0]?.arrival?.datetime?.time_12h}} - {{data?.flights[0]?.arrival?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.flights[0]?.arrival?.airport?.name}} ({{data?.flights[0]?.arrival?.airport?.code}})
                </p>

              </div>
            </div>
            <div *ngIf="data?.info?.layovers" class="layover py-2 mb-2">
              Layover: {{data?.info?.layovers[0]?.duration}} in
              {{data?.flights[0]?.arrival?.airport?.city}}

             
            </div>
            <div class="d-flex gap-3 mt-1">
              <fa-icon [icon]="icons.departure"></fa-icon>
              <div class="mb-2">
                <p class="mb-2">
                  Flight number: {{data?.flights[1]?.info.operating_airline_code+''+data?.flights[1]?.info.flight_number}}
                </p>
                <p class="mb-2">
                  Duration: {{data?.flights[1]?.info.duration | flyOverDuration}}
                </p>
                <p class="mb-2">
                  {{data?.flights[1]?.departure?.datetime?.time_12h}} - {{data?.flights[1]?.departure?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.flights[1]?.departure?.airport?.name}} ({{data?.flights[1]?.departure?.airport?.code}})
                </p>

                <div class="my-4">
                  <p class="mb-2">
                    <!-- 4h 30m flight -->
                  </p>
                  <p class="mb-2">
                    Operating Airline: {{data?.flights[1]?.info?.operating_airline}}
                  </p>
                  <p class="mb-2">
                    Marketing Airline: {{data?.flights[1]?.info?.marketing_airline}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[1]?.info?.aircraft}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[1]?.info?.aircraft_type}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[1]?.info?.cabin_name}}
                  </p>
                  <div *ngIf="data?.flights[1]?.info?.notes?.length > 0">
                    Notes:
                    <ul >
                      <li *ngFor="let item of data?.flights[1]?.info?.notes" class="mb-0">{{item?.value}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="stopCount === 2">

            <div class="d-flex gap-3 mt-1">
              <fa-icon [icon]="icons.arrival"></fa-icon>
              <div class="mb-2">
                <p class="mb-2">
                  {{data?.flights[0]?.arrival?.datetime?.time_12h}} - {{data?.flights[0]?.arrival?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.flights[0]?.arrival?.airport?.name}} ({{data?.flights[0]?.arrival?.airport?.code}})
                </p>

              </div>
            </div>
            <div *ngIf="data?.info?.layovers" class="layover py-2 mb-2">
              Layover: {{data?.info?.layovers[0]?.duration}} in
              {{data?.flights[0]?.arrival?.airport?.city}}
            </div>
            <div class="d-flex gap-3 mt-1">
              <fa-icon [icon]="icons.departure"></fa-icon>
              <div class="mb-2">
                <p class="mb-2">
                  Flight number: {{data?.flights[1]?.info.operating_airline_code+''+data?.flights[1]?.info.flight_number}}
                </p>
                <p class="mb-2">
                  Duration: {{data?.flights[1]?.info.duration | flyOverDuration}}
                </p>
                <p class="mb-2">
                  {{data?.flights[1]?.departure?.datetime?.time_12h}} - {{data?.flights[1]?.departure?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.flights[1]?.departure?.airport?.name}} ({{data?.flights[1]?.departure?.airport?.code}})
                </p>

                <div class="my-4">
                  <p class="mb-2">
                    <!-- 4h 30m flight -->
                  </p>
                  <p class="mb-2">
                    Operating Airline: {{data?.flights[1]?.info?.operating_airline}}
                  </p>
                  <p class="mb-2">
                    Marketing Airline: {{data?.flights[1]?.info?.marketing_airline}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[1]?.info?.aircraft}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[1]?.info?.aircraft_type}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[1]?.info?.cabin_name}}
                  </p>
                  <div *ngIf="data?.flights[1]?.info?.notes?.length > 0">
                    Notes:
                    <ul >
                      <li *ngFor="let item of data?.flights[1]?.info?.notes" class="mb-0">{{item?.value}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex gap-3 mt-1">
              <fa-icon [icon]="icons.arrival"></fa-icon>
              <div class="mb-2">
                <p class="mb-2">
                  {{data?.flights[1]?.arrival?.datetime?.time_12h}} - {{data?.flights[1]?.arrival?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.flights[1]?.arrival?.airport?.name}} ({{data?.flights[1]?.arrival?.airport?.code}})
                </p>

              </div>
            </div>
            <div *ngIf="data?.info?.layovers" class="layover py-2 mb-2">
              Layover: {{data?.info?.layovers[1]?.duration}} in
              {{data?.flights[1]?.arrival?.airport?.city}}
            </div>
            <div class="d-flex gap-3 mt-1">
              <fa-icon [icon]="icons.departure"></fa-icon>
              <div class="mb-2">
                <p class="mb-2">
                  Flight number: {{data?.flights[2]?.info.operating_airline_code+''+data?.flights[2]?.info.flight_number}}

                </p>
                <p class="mb-2">
                  Duration: {{data?.flights[2]?.info.duration | flyOverDuration}}
                </p>
                <p class="mb-2">
                  {{data?.flights[2]?.departure?.datetime?.time_12h}} - {{data?.flights[2]?.departure?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.flights[2]?.departure?.airport?.name}} ({{data?.flights[2]?.departure?.airport?.code}})
                </p>

                <div class="my-4">
                  <p class="mb-2">
                    <!-- 4h 30m flight -->
                  </p>
                  <p class="mb-2">
                    Operating Airline: {{data?.flights[data?.flights?.length - 1]?.info?.operating_airline}}
                  </p>
                  <p class="mb-2">
                    Marketing Airline: {{data?.flights[data?.flights?.length - 1]?.info?.marketing_airline}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[data?.flights?.length - 1]?.info?.aircraft}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[data?.flights?.length - 1]?.info?.aircraft_type}}
                  </p>
                  <p class="mb-2">
                    {{data?.flights[data?.flights?.length - 1]?.info?.cabin_name}}
                  </p>
                  <div *ngIf="data?.flights[data?.flights?.length - 1]?.info?.notes?.length > 0">
                    Notes:
                    <ul >
                      <li *ngFor="let item of data?.flights[data?.flights?.length - 1]?.info?.notes" class="mb-0">{{item?.value}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="d-flex gap-3 mt-4">
            <fa-icon [icon]="icons.arrival"></fa-icon>
            <div>
              <div class="mb-4">
                <p class="mb-2">
                  {{data?.arrival?.datetime?.time_12h}} - {{data?.arrival?.airport?.city}}
                </p>
                <p class="mb-2">
                  {{data?.arrival?.airport?.name + ' ' + data?.arrival?.airport?.code }}
                </p>
              </div>

              
            </div>
          </div>

          <p>Additional bags for this flight must be purchased through the airline after booking.</p>
          <p> <a [href]="'https://'+data?.flights[0]?.baggage_allowances[0]?.baggage_info_url" target="_blank">
              {{data?.flights[0]?.info?.operating_airline}} baggage fee information</a> </p>

          <!-- <div class="ps-4">
            <span class="select-fare-badge-alt">
              Above average CO2
            </span>
          </div> -->

        </div>
      </div>
    </div>
  </div>
</div>
